import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=8adf9476&scoped=true&"
import script from "./Document.ts?vue&type=script&lang=ts&"
export * from "./Document.ts?vue&type=script&lang=ts&"
import style0 from "./Document.vue?vue&type=style&index=0&id=8adf9476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adf9476",
  null
  
)

export default component.exports